import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1920,1672.03136 L1920,1778.70039 L533.302518,1778.70039 L533.302518,1672.03136 L1920,1672.03136 Z M357.661281,141 L662.094713,445.326763 L357.661281,749.760195 L282.352941,674.238516 L457.930176,498.661281 L106.562368,498.661281 L106.562368,1778.68973 L0,1778.68973 L0,392.098913 L457.930176,392.098913 L282.352941,216.30834 L357.661281,141 Z M1920,1245.24854 L1920,1352.02424 L533.302518,1352.02424 L533.302518,1245.24854 L1920,1245.24854 Z M1920,818.67906 L1920,925.348097 L533.302518,925.348097 L533.302518,818.67906 L1920,818.67906 Z M1066.6477,392.002911 L1066.6477,498.671948 L853.309629,498.671948 L853.309629,392.002911 L1066.6477,392.002911 Z M1493.32385,392.002911 L1493.32385,498.671948 L1279.98578,498.671948 L1279.98578,392.002911 L1493.32385,392.002911 Z M1920,392.002911 L1920,498.671948 L1706.66193,498.671948 L1706.66193,392.002911 L1920,392.002911 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMoveUpTopLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMoveUpTopLine, _Component);

  var _super = _createSuper(IconMoveUpTopLine);

  function IconMoveUpTopLine() {
    _classCallCheck(this, IconMoveUpTopLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMoveUpTopLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMoveUpTop",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMoveUpTopLine.displayName = "IconMoveUpTopLine";
  return IconMoveUpTopLine;
}(Component);

IconMoveUpTopLine.glyphName = 'move-up-top';
IconMoveUpTopLine.variant = 'Line';
IconMoveUpTopLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMoveUpTopLine;
export { IconMoveUpTopLine };